export default "__VITE_ASSET__DuI9D0$c__"